import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { colors } from '../../../constants'

export const Note = styled.li`
    padding-bottom: 18px;
    padding-top: 18px;
    padding-left: 10px;
    padding-right: 0;
    position: relative;
    display: block;

    ${({ pinned }) => (!pinned ? `border-bottom: 1px solid ${colors.greylight};` : `border: 1px dotted ${colors.bluelighter};`)}

    &:last-child {
        ${({ pinned }) => !pinned && 'border-bottom: 0;'}
    }

    &:hover {
        ${({ pinned }) => pinned && `background-color: ${colors.bluenotsolightest};`}
    }
`

export const NoteInfo = styled.div`
    font-size: 10px;
    margin-top: 5px;
    display: block;
    color: ${colors.grey};
`

export const StickyIcon = styled(FontAwesomeIcon)`
    color: ${colors.greylight};
    opacity: 0;
    position: absolute;
    right: 10px;
    transition: all 0.3s;
    top: 8px;

    opacity: ${({ pinned }) => (pinned ? '1' : '0')};

    ${({ pinned }) => !pinned && 'transform: translate(1px, -2px)rotate(45deg);'};

    &:hover {
        color: ${(props) => `${props.pinned ? colors.red : colors.green}90`} !important;
        ${({ pinned }) => (pinned ? 'transform: translate(1px, -2px)rotate(45deg);' : 'transform: none')};
    }

    li:hover > & {
        color: ${({ pinned }) => (pinned ? colors.grey : colors.greylight)};
        cursor: pointer;
        opacity: 1;
    }
`

export const TrashIcon = styled(FontAwesomeIcon)`
    opacity: 0;
    position: absolute;
    right: 30px;
    transition: opacity 0.3s;
    top: 8px;

    color: ${(props) => (props.pinned ? colors.grey : colors.greylight)};

    &:hover {
        color: ${colors.red}90;
    }

    li:hover > * > & {
        cursor: pointer;
        opacity: 1;
    }
`
